import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import Helmet from 'react-helmet'

import {Icon} from 'react-fa'
import Obfuscate from 'react-obfuscate'  /* https://www.npmjs.com/package/react-obfuscate */

/* import { Follow } from 'react-twitter-widgets' */

import divider3 from '../../img/bg/divider3.jpg';

class HeaderComplete extends React.Component {
  render() {
    // console.log("props", this.props)
    // const pageLinks = []
    // const site = get(this, 'props.data.site.siteMetadata')
    return (
		<div id="headerwrap" name="home" style={{backgroundImage: 'url(' + divider3 + ')' }} >
			<header className="clearfix">
				<h1><span className="icon icon-w"></span></h1>
				<p>Christian Wolter</p>
			</header>
		</div>
		)
	}
}

class Footer extends React.Component {
	constructor() {
		super();
		 this.state = {
				intervalId: 0
		};
	}

	scrollStep() {
		if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
		}
		window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
	}

	scrollToTop() {
		let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
		this.setState({ intervalId: intervalId });
	}
	render () {
		return <div>
							<div id="footerwrap">
									 <div className="container">
											 <h4><small>created by Christian Wolter - copyright 2019 - <Link to='/imprint' onClick={ () => { this.scrollToTop(); }}>imprint | disclaimer</Link> -  <Link to='/privacy' onClick={ () => { this.scrollToTop(); }}>privacy</Link></small></h4>
									 </div>
							</div>
						</div>;
	 }
 }

class ScrollButton extends React.Component {
 constructor() {
	 super();
		 this.state = {
			 intervalId: 0
	 };
 }

 scrollStep() {
	 if (window.pageYOffset === 0) {
			 clearInterval(this.state.intervalId);
	 }
	 window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
 }

 scrollToTop() {
	 let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
	 this.setState({ intervalId: intervalId });
 }

 render () {
		 return <button title='Back to top' className='scroll'
							onClick={ () => { this.scrollToTop(); }}>
							 <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
						 </button>;
	}
}

let spacer = {
	paddingLeft: '30px'
}

let iconStyle = {
	opacity: '0.5',
	width: '30px'
}

class Projects extends React.Component {
  render() {
    const pathPrefix =
      process.env.NODE_ENV === 'development' ? '' : __PATH_PREFIX__
    return (
			<div>
				<HeaderComplete />
				<div className="container" id="disclaimer" name="disclaimer">
					<br/>
					<br/>
					<div className="row">
					<br/>
						<h1 className="centered">contact</h1>
						<hr/>
						<br/>
						<br/>
						<div className="col-md-4">
								<h3>contact</h3>
								<p><Icon name="user" style={ iconStyle } />Christian Wolter<br/>
									<Icon name="map-marker" style={ iconStyle } />Poppenreutherstr. 49a<br/>
									<span style={ spacer }>90419 Nürnberg</span><br/>
									<Icon name="envelope" style={ iconStyle } />
										<Obfuscate
											email='contact@christian-wolter.com'
											headers={
												{subject:'Contact via webpage'}
											}/>
								</p>
					</div>

					<div className="col-md-4">
            {
            // <h3>twitter</h3>
						//	<p>
            //    <Icon name="twitter" style={ iconStyle } /><a href="https://twitter.com/3xmo" target="_blank">twitter.com/3xmo</a>

                  //<Icon name="twitter" style={ iconStyle } /><a href="https://twitter.com/3xmo_de" target="_blank">twitter.com/3xmo_de</a> <small>(german)</small>

						//	</p>
            }
						<h3>LinkedIn</h3>
						<p><Icon name="linkedin" style={ iconStyle } /> <a href="https://www.linkedin.com/in/christian-wolter/" target="_blank">LinkedIn.com</a></p>
            <h3>xing</h3>
						<p><Icon name="xing" style={ iconStyle } /> <a href="https://www.xing.com/profile/Christian_Wolter10" target="_blank">xing.com</a></p>
					</div>

					<div className="col-md-4">
								<h3>blog:</h3>
								<p><Icon name="rss" style={ iconStyle } /><a href="http://blog.christian-wolter.com">blog.christian-wolter.com</a></p>
						</div>

					</div>
				</div>
				<ScrollButton scrollStepInPx="50" delayInMs="16.66" />
				<Footer />
			</div>
    )
  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/pages/contact/index.jsx